import React from 'react';

import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import MobileScreenshotsSection from './MobileScreenshotsSection';
import BusinessSection from './BusinessSection';
import NewsletterSection from './NewsletterSection';
import css from './LandingPage.module.css';
import ProviderTypesSection from './ProviderTypesSection';

const LogoSVG = () => {
  return (
    <svg
      aria-hidden="true"
      height="1em"
      role="img"
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      className="size-8 text-primary"
    >
      <path fill="currentColor" d="M21 4.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0"></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.972 5.81a3.7 3.7 0 0 1 2.846-.062c2.568 1 3.188 4.35 1.15 6.204l-1.04.946l-.06.054a1.25 1.25 0 0 0 .148 1.938l.004.002l.125.096a7.75 7.75 0 0 1 3.005 6.202V22a.75.75 0 0 1-1.5 0v-.951a6.25 6.25 0 0 0-2.54-4.964l-.006-.005l-.081-.062a2.75 2.75 0 0 1-.11-4.225l1.045-.95c1.215-1.105.845-3.102-.685-3.698a2.2 2.2 0 0 0-1.695.037l-.522.23c-.545.241-.797.352-1.042.474a12 12 0 0 0-1.2.683c-.23.148-.455.308-.94.654l-1.439 1.024a.75.75 0 1 1-.87-1.222L5.021 7.99c.464-.331.717-.511.978-.68q.653-.421 1.348-.767c.279-.138.563-.263 1.085-.493zm6.3 6.008a.75.75 0 0 1 .91-.546a7.5 7.5 0 0 0 3.636 0a.75.75 0 0 1 .364 1.456a9 9 0 0 1-4.364 0a.75.75 0 0 1-.546-.91M9.48 16.424a.75.75 0 0 1 .096 1.056l-.26.311A8.22 8.22 0 0 1 3 20.75a.75.75 0 0 1 0-1.5a6.72 6.72 0 0 0 5.164-2.419l.26-.311a.75.75 0 0 1 1.056-.096"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

const FootFallLandingPage = () => {
  return (
    <div className={css.landingPageWrapper}>
      <HeroSection />
      <MobileScreenshotsSection />
      <FeaturesSection />
      <BusinessSection />
      <ProviderTypesSection />
      {/*<NewsletterSection />*/}
    </div>
  );
};

export default FootFallLandingPage;
